var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container box runner",staticStyle:{"margin-bottom":"1rem"}},[_c('p',{staticClass:"title is-2 is-spaced"},[_vm._v(_vm._s(_vm.runnerInfo.name))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"subtitle is-spaced"},[_vm._v("Summary")]),_vm._v(" "),_c('runner-summary',{attrs:{"info":_vm.runnerInfo}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71d88a02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Runner.vue
// module id = 101
// module chunks = 0